module.exports = __webpack_public_path__ + "assets/img/status-overdue-wcag.7d868458.svg";